import { useRef } from 'react';

const portfolioItems = [
  {
    image: 'https://public.readdy.ai/ai/img_res/7e0f78f903e200b8836da6762a12c1d9.jpg',
    category: 'Real Estate',
    title: 'Luxury Property Showcase',
    description: 'Premium real estate platform with advanced search and virtual tours'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=E-commerce%20fashion%20store%20website%20design%2C%20stylish%20product%20displays%2C%20modern%20shopping%20interface%2C%20clean%20white%20background%2C%20professional%20fashion%20photography%2C%20elegant%20layout&width=480&height=300&seq=portfolio-fashion&orientation=landscape',
    category: 'E-commerce',
    title: 'Fashion Boutique Online',
    description: 'Elegant online store with seamless checkout experience'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Restaurant%20website%20design%20with%20beautiful%20food%20photography%2C%20menu%20showcase%2C%20modern%20dining%20interface%2C%20clean%20white%20background%2C%20professional%20culinary%20presentation&width=480&height=300&seq=portfolio-restaurant&orientation=landscape',
    category: 'Restaurant',
    title: 'Gourmet Dining Experience',
    description: 'Interactive menu and reservation system for fine dining'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Healthcare%20medical%20clinic%20website%20design%2C%20professional%20doctor%20profiles%2C%20modern%20patient%20portal%20interface%2C%20clean%20white%20background%2C%20trustworthy%20medical%20presentation&width=480&height=300&seq=portfolio-healthcare&orientation=landscape',
    category: 'Healthcare',
    title: 'Medical Practice Portal',
    description: 'Patient-friendly booking system with telehealth integration'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fitness%20gym%20website%20design%2C%20workout%20programs%20showcase%2C%20modern%20training%20interface%2C%20clean%20white%20background%2C%20energetic%20sports%20photography%2C%20motivational%20layout&width=480&height=300&seq=portfolio-fitness&orientation=landscape',
    category: 'Fitness',
    title: 'Fitness Studio Hub',
    description: 'Class scheduling and membership management platform'
  }
];

export default function Portfolio() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 504;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex justify-between items-end mb-12">
          <div>
            <p className="text-sm text-gray-500 mb-2 uppercase tracking-wider">Featured Work</p>
            <h2 className="text-5xl lg:text-6xl font-serif italic text-gray-900">Recent Projects</h2>
          </div>
          <div className="hidden lg:flex gap-3">
            <button
              onClick={() => scroll('left')}
              className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#FF6B6B] hover:text-[#FF6B6B] transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-12 h-12 rounded-full bg-[#1A1D29] text-white flex items-center justify-center hover:bg-[#FF6B6B] transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto scrollbar-hide scroll-smooth pb-4"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {portfolioItems.map((item, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-[480px] group cursor-pointer"
            >
              <div className="relative rounded-3xl overflow-hidden mb-4">
                <div className="w-full h-72">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-8">
                  <div className="text-white">
                    <h3 className="text-2xl font-bold mb-2">{item.title}</h3>
                    <p className="text-sm text-gray-200">{item.description}</p>
                  </div>
                </div>
                <div className="absolute top-6 left-6">
                  <span className="bg-white text-gray-900 text-xs font-semibold px-4 py-2 rounded-full">
                    {item.category}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
